
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Unit 6',
    id: 'WB4-V2-U6-P42-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 2,
    exerciseKey: 'img/FriendsPlus/Page42/E1/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page42/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page42/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page42/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page42/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page42/E1/5.jpg', input: 2 },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page42/E1/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page42/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page42/E1/8.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page42/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page42/E1/10.jpg', input: 2, isCorrect: true },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page42/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page42/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page42/E1/13.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page42/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page42/E1/15.jpg', input: 2 },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page42/E1/16.jpg' },
      ],


    ]
  },
  2: { // Exercise num
    unit: 'Unit 6',
    id: 'WB4-V2-U6-P42-E2',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page42/E2/Key/answerKey.png',
    component: D1,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page42/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page42/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page42/E2/3.jpg', input: true, answer: "in the evening" },
        { url: 'img/FriendsPlus/Page42/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page42/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page42/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page42/E2/7.jpg', input: true, answer: "in the afternoon" },
        { url: 'img/FriendsPlus/Page42/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page42/E2/9.jpg', input: true, answer: "in the morning" },
        { url: 'img/FriendsPlus/Page42/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page42/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page42/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page42/E2/13.jpg', input: true, answer: "in the afternoon" },
        { url: 'img/FriendsPlus/Page42/E2/14.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page42/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page42/E2/15.jpg' },
      ],



    ],
  },
  3: { // Exercise num
    unit: 'Unit 6',
    id: 'WB4-V2-U6-P42-E3',
    audio: '',
    recorder: true,
    video: '',
    component: UI,
    titleImage: '',
    // exerciseKey: 'img/FriendsPlus/Page42/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page42/E3/1.jpg' },
      ],
    ]
  },

}

export default json;